
<script>
    import { getNewIcon } from '../../card_images';
	import "../shared.css";
</script>

<div class="tr-black" />
<div class="tr-focus research" />
<div class="tr-focus influence" />
<div class="tr-focus military" />
<div class="score-icons">
	<img src={getNewIcon('research')} class="research" style="height:0.8em" />
	<img src={getNewIcon('influence')} class="influence" style="height:0.6em" />
	<img src={getNewIcon('military')} class="military" style="height:0.8em" />
	<img src={getNewIcon('?vp')} style="height:1.6em" />
</div>

<style lang="scss">
	.score-icons {
		position: absolute;
		width: min-content;
		height: min-content;
		top: calc(0px - var(--height) / 80.2); // -5px;
		right: 0.45em;
		align-items: center;
		z-index: 10;
		& > :global(.research) {
			position: absolute;
			left: calc(0px - var(--width) / 57.4); // -5px;
			top: 15%;
			transform: translateX(-60%);
		}
		& > :global(.influence) {
			position: absolute;
			left: calc(0px - var(--width) / 26.091); // -11px;
			top: 64%;
			transform: translateY(-40%) translateX(-110%);
		}
		& > :global(.military) {
			position: absolute;
			left: calc(0px - var(--width) / 57.4); // -5px;
			bottom: -15%;
			transform: translateX(-60%);
		}
	}
	.tr-black {
		position: absolute;
		width: calc(var(--height) / 22.278); //18px;
		height: calc(var(--height) / 16.04); //25px;
		clip-path: polygon(100% 0, 100% 100%, 0 100%);
		background: black;
		right: 0;
		bottom: -0.05em;
		z-index: 2;
	}
	.tr-focus {
		position: absolute;
		right: 0;
		bottom: -0.05em;
		&.research {
			background-image: linear-gradient(
				215deg,
				rgba(30, 30, 30, 1) 0%,
				rgb(14, 134, 214) 15%,
				rgba(45, 167, 215, 1) 40%,
				rgb(14, 134, 214) 65%,
				rgba(30, 30, 30, 1) 100%
			);
			width: calc(var(--height) / 6.683); //60px;
			height: calc(var(--height) / 7.291); //55px;
			clip-path: polygon(100% 0, 100% 100%, 0 100%);
			z-index: -4;
		}
		&.influence {
			background-image: linear-gradient(
				215deg,
				rgba(30, 30, 30, 1) 0%,
				rgba(193, 180, 0, 1) 15%,
				rgba(233, 220, 32, 1) 40%,
				rgba(193, 180, 0, 1) 65%,
				rgba(30, 30, 30, 1) 100%
			);
			width: calc(var(--height) / 8.911); // 45px;
			height: calc(var(--height) / 8.911); //45px;
			clip-path: polygon(100% 0, 100% 100%, 0 100%);
			z-index: -3;
		}
		&.military {
			background-image: linear-gradient(
				215deg,
				rgba(30, 30, 30, 1) 0%,
				rgba(171, 0, 59, 1) 15%,
				rgba(210, 38, 98, 1) 40%,
				rgba(171, 0, 59, 1) 65%,
				rgba(30, 30, 30, 1) 100%
			);
			width: calc(var(--height) / 13.367); //30px;
			height: calc(var(--height) / 11.457); //35px;
			clip-path: polygon(100% 0, 100% 100%, 0 100%);
			z-index: -2;
		}
	}
</style>
